{
  "moreActions": "Περισσότερες ενέργειες",
  "unavailable": "Μη διαθέσιμο, ανάπτυξη για λεπτομέρειες"
}
